export const crearPacienteVacio = (valores = {}) => ({
  IdPaciente: null,
  Nombre: "",
  EncargadoLegalNombreCompleto: "",
  Telefono: "",
  Email: "",
  FechaNacimiento: "",
  Estado: 1,
  ...valores
});

export const getBirthDate = (patient) =>
  patient?.FechaNacimiento ||
  patient?.FechaDeNacimiento ||
  patient?.fechaNacimiento ||
  patient?.fecha_nacimiento ||
  "";

export const crearPacienteFormulario = (paciente = {}) =>
  crearPacienteVacio({
    ...paciente,
    IdPaciente: paciente.IdPaciente ?? null,
    Nombre: paciente.Nombre || "",
    EncargadoLegalNombreCompleto: paciente.EncargadoLegalNombreCompleto ?? "N/A",
    Telefono: paciente.Telefono || "",
    Email: paciente.Email || "",
    FechaNacimiento: getBirthDate(paciente) ? String(getBirthDate(paciente)).slice(0, 10) : "",
    Estado: paciente.Estado ?? 1
  });

export const calculateAge = (birthDate, referenceDate = new Date(), suffix = "") => {
  if (!birthDate) return "N/A";

  const birth = new Date(`${String(birthDate).slice(0, 10)}T00:00:00`);
  const reference = referenceDate instanceof Date
    ? referenceDate
    : new Date(String(referenceDate).replace(" ", "T"));

  if (Number.isNaN(birth.getTime()) || Number.isNaN(reference.getTime())) return "N/A";

  let age = reference.getFullYear() - birth.getFullYear();
  const referenceMonth = reference.getMonth();
  const referenceDay = reference.getDate();
  const birthMonth = birth.getMonth();
  const birthDay = birth.getDate();

  if (referenceMonth < birthMonth || (referenceMonth === birthMonth && referenceDay < birthDay)) {
    age -= 1;
  }

  if (age < 0) return "N/A";
  return suffix ? `${age} ${suffix}` : age;
};
